import { Pipe, PipeTransform } from '@angular/core';
  
@Pipe({
  name: 'yesNo'
})
export class YesNoPipe {
  transform(value:boolean) {    
    //console.log(value)    
    return value ? 'Activo' : 'Inactivo';;
  }
}